
import React, { Component } from 'react';
import { Modal, Form, Input, InputNumber } from 'antd';

import http from '../../../axios/http';
import messager from '../../ui/messager';
import validator from '../../../util/validator';

const fields = [{
    "text": "服务费用",
    "field": "amount",
    "label": true
}, {
    "text": "买家名称",
    "field": "buyerName",
    "label": true
}, {
    "text": "买家证件号",
    "field": "buyerCreditNo",
    "label": true
}, {
    "text": "卖家名称",
    "field": "sellerName",
    "label": true
}, {
    "text": "卖家证件号",
    "field": "sellerCreditNo",
    "label": true
}, {
    "text": "交款人",
    "field": "payer",
    rules: [
        { required: true, message: '交款人不能为空!' },
        { max: 32, message: '交款人不能超过32个字符！' },
    ]
}, {
    "text": "交款人证件号",
    "field": "payerCreditNo",
    rules: [
        { required: true, message: '交款人证件号不能为空!' },
        validator.creditNo
    ]
}, {
    "text": "发票号码",
    "field": "invoiceNumber",
    rules: [
        { max: 16, message: '发票号码不能超过16个字符！' },
    ]
}, {
    "text": "备注",
    "field": "remark",
    textarea: true,
    rules: [
        { max: 32, message: '备注不能超过64个字符！' },
    ]
}];


class PersonChargeForm extends Component {

    state = {}

    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            values["applicationId"] = this.props.editData.applicationId;
            http.post({
                url: '/application/doPersonCharge',
                data: values,
                success: (res) => {
                    this.props.successCallback(this.props.queryData);
                    this.props.onCancel();
                    messager.notify("保存成功！");
                }
            });
        });
    };


    createDom = (data) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let itemDom = (
                <Form.Item key={i} label={item.text + "："}>
                    {
                        getFieldDecorator(item.field, {
                            rules: item.rules,
                            initialValue: editData[item.field],
                        })(

                            item.number ?
                                <InputNumber precision={0} min={1} max={1000} style={{ width: '100%' }} />
                                : item.textarea ? <Input.TextArea />
                                    : item.label ? <span>{editData[item.field]}</span>
                                        : <Input />
                        )
                    }
                </Form.Item>
            );
            dom.push(itemDom);
        }
        return dom;
    };

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                visible={visible}
                title="个人服务收费记录"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.props.form.resetFields(); }}
            >
                <Form layout="vertical" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                    {this.createDom(fields)}
                </Form>
            </Modal>
        );
    }
}

const PersonCharge = Form.create()(PersonChargeForm);

export default PersonCharge;